import styled from "styled-components";

export const UiRuleSearchSourceContainer = styled.div`
	display: block;
	height: 100%;
`;
